import { connect } from 'react-redux'
import { compose } from 'lodash/fp'
import { Dispatch } from 'redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
import changeReservationFormConfiguration from '../../../actions/bookingCalendar/reservationModal/changeConfiguration'
import { IStore } from '../../../reducers'
import {
  getFieldsVisibility,
  getReservationFormVeryCurrentTab,
} from '../../../reducers/bookingCalendar/selectors/reservationForm'
import { IModalReservationProps } from './ModalReservation'
import { Mixpanel } from '../../../utils/Mixpanel'

export class ReservationFormFieldVisibility {
  public advancePaymentDate = false
  public advancePayment = true
  public advancePaymentType = false
  public additionalServices = false
  public daysCount = true
  public additionalGuests = false
  public deposit = false
  public company = false
  public pricePerDay = false
  public pricePerPerson = false
  public email = true
  public reservationTime = false
  public doorCode = false
  public setCustomColor = false
  public creationDate = false
  public onSitePaymentDate = false
  public feeding = false
  public timeToPayDays = false
  public localTax = false
  public onSitePayment = true
  public numberOfBeds = false
  public reservationSource = false
  public residenceRegistration = false
  public onSitePaymentType = false

  public constructor(isNew = false) {
    if (!isNew) {
      this.pricePerDay = true
      this.deposit = true
      this.localTax = true
      this.timeToPayDays = true
      this.additionalServices = true
      this.company = true
      this.feeding = true
      this.residenceRegistration = true
      this.doorCode = true
    }
  }
}

export interface IModalReservationValues {
  fieldVisibility: ReservationFormFieldVisibility
}

export const FORM_NAME = 'config_form'

const withReduxForm = reduxForm<
  IModalReservationValues,
  IModalReservationProps
>({
  destroyOnUnmount: false,
  enableReinitialize: false,
  onChange(
    values: Partial<IModalReservationValues>,
    dispatch: Dispatch<any>,
    props: IModalReservationProps &
      InjectedFormProps<
        IModalReservationValues,
        IModalReservationProps,
        string
      >,
    previousValues: Partial<IModalReservationValues>,
  ) {
    const fieldVisibility = values.fieldVisibility

    function getFieldsVisibilityArray() {
      const fieldsVisibilityArray = []
      if (fieldVisibility.advancePaymentDate) {
        fieldsVisibilityArray.push('Date of payment - Down payment')
      }
      if (fieldVisibility.advancePayment) {
        fieldsVisibilityArray.push('Payment - Down payment')
      }
      if (fieldVisibility.advancePaymentType) {
        fieldsVisibilityArray.push('Payment - Down payment type')
      }
      if (fieldVisibility.additionalServices) {
        fieldsVisibilityArray.push('Additional services')
      }
      if (fieldVisibility.daysCount) {
        fieldsVisibilityArray.push('No. of days')
      }
      if (fieldVisibility.additionalGuests) {
        fieldsVisibilityArray.push('Remaining people')
      }
      if (fieldVisibility.deposit) {
        fieldsVisibilityArray.push('Deposit')
      }
      if (fieldVisibility.company) {
        fieldsVisibilityArray.push('Company')
      }
      if (fieldVisibility.pricePerDay) {
        fieldsVisibilityArray.push('Price per day')
      }
      if (fieldVisibility.pricePerPerson) {
        fieldsVisibilityArray.push('Price per person')
      }
      if (fieldVisibility.email) {
        fieldsVisibilityArray.push('Email')
      }
      if (fieldVisibility.reservationTime) {
        fieldsVisibilityArray.push('Hours')
      }
      if (fieldVisibility.doorCode) {
        fieldsVisibilityArray.push('Entrance code')
      }
      if (fieldVisibility.setCustomColor) {
        fieldsVisibilityArray.push('Own colour of reservation')
      }
      if (fieldVisibility.creationDate) {
        fieldsVisibilityArray.push('Added')
      }
      if (fieldVisibility.onSitePaymentDate) {
        fieldsVisibilityArray.push('Date of payment - Payment on place')
      }
      if (fieldVisibility.feeding) {
        fieldsVisibilityArray.push('Board')
      }
      if (fieldVisibility.localTax) {
        fieldsVisibilityArray.push('Local tax')
      }
      if (fieldVisibility.reservationSource) {
        fieldsVisibilityArray.push('Booking origin')
      }
      if (fieldVisibility.onSitePayment) {
        fieldsVisibilityArray.push('Payment - Payment on place')
      }
      if (fieldVisibility.onSitePaymentType) {
        fieldsVisibilityArray.push('Payment - Payment on place type')
      }
      if (fieldVisibility.residenceRegistration) {
        fieldsVisibilityArray.push('Registration')
      }
      if (fieldVisibility.numberOfBeds) {
        fieldsVisibilityArray.push('Number of beds')
      }
      if (fieldVisibility.timeToPayDays) {
        fieldsVisibilityArray.push('Time of waiting for the payment')
      }
      return fieldsVisibilityArray
    }

    Mixpanel.track('Reservation Add Another Field Used', {
      'Reservation Fields': getFieldsVisibilityArray(),
    })
  },
  form: FORM_NAME,
  onSubmit: (values, dispatch: Dispatch) => {
    dispatch(changeReservationFormConfiguration(values, FORM_NAME))
  },
})

const mapStateToProps = (state: IStore) => {
  return {
    initialTab: getReservationFormVeryCurrentTab(state),
    initialValues: {
      fieldVisibility: getFieldsVisibility(state),
    },
  }
}

const withInitialValues = connect(mapStateToProps)

export default compose(
  withInitialValues,
  withReduxForm,
)
